import React from "react";
var __jsx = React.createElement;
import { useState } from 'react';
import { PublishDialog } from 'components/content/PublishDialog';
import { Container } from './ContentSidebar.style';
import { PreviewButton } from './PreviewButton';
import { PublishButton } from './PublishButton';
import { SaveButton } from './SaveButton';

var ContentSidebar = function ContentSidebar(_ref) {
  var _ref$state = _ref.state,
      newPublicationStatus = _ref$state.newPublicationStatus,
      scheduledPublicationDate = _ref$state.scheduledPublicationDate,
      lastModified = _ref.lastModified,
      onDialogClose = _ref.onDialogClose,
      onPublishConfirm = _ref.onPublishConfirm,
      submitForm = _ref.submitForm,
      isPublishing = _ref.isPublishing;
  var scheduledDate = scheduledPublicationDate === undefined ? undefined : new Date(scheduledPublicationDate);

  var _useState = useState(false),
      publishDialogOpen = _useState[0],
      setPublishDialogOpen = _useState[1];

  var handlePublishConfirm = function handlePublishConfirm(newStatus) {
    var newScheduledDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    handlePublishDialogClose(); // Setting the state will trigger a form submission

    onPublishConfirm(newStatus, newScheduledDate);
  };

  var handlePublishDialogClose = function handlePublishDialogClose() {
    setPublishDialogOpen(false);

    if (onDialogClose !== undefined) {
      onDialogClose();
    }
  };

  return __jsx(React.Fragment, null, __jsx(Container, null, __jsx(PreviewButton, {
    publicationStatus: newPublicationStatus
  }), __jsx(SaveButton, {
    onClick: submitForm,
    lastModified: lastModified
  }), __jsx(PublishButton, {
    onClick: function onClick() {
      return setPublishDialogOpen(true);
    },
    publicationStatus: newPublicationStatus,
    scheduledPublicationDate: scheduledDate
  })), __jsx(PublishDialog, {
    open: publishDialogOpen,
    onClose: handlePublishDialogClose,
    onConfirm: handlePublishConfirm,
    publicationStatus: newPublicationStatus,
    publishingLoading: isPublishing,
    initialScheduledDate: scheduledDate
  }));
};

export default ContentSidebar;